import ThemeEditorModal from './ThemeEditorModal';

export default ThemeEditorModal;
